import { FlagshipFundStrategies } from '@api/sanity/graphql/queries/flagship-fund-strategies';
import { SanityFlagshipFundStrategies } from 'types/sanity/marketing-components';
import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

type SanityFlagshipStrategiesSectionResponse = SanityGraphQLResponse<
	SanityFlagshipFundStrategies,
	'allFlagshipFundStrategiesContent'
>;

export async function getFlagshipFundStrategies(): Promise<SanityFlagshipFundStrategies | null> {
	const { data } = await useQuery<SanityFlagshipStrategiesSectionResponse>({
		client: villusClient,
		query: FlagshipFundStrategies,
		tags: ['flagship_fund_strategies']
	}).execute();

	return data?.allFlagshipFundStrategiesContent[0] ?? null;
}
